import React from 'react';

const VolunteerSection = ({ t }: any) => (
  <section id="volunteers" className="volunteer-section">
    <h2>{t.becomeVolunteer}</h2>
    <p>{t.volunteerDesc}</p>
    <p className="volunteer-info">{t.volunteerInfo}</p>
  </section>
);

export default VolunteerSection;
